// Small shared helpers with no domain dependencies.
// Exhaustiveness guard for discriminated-union switches. Used as
// `default: assertNever(x)` (or the if-chain equivalent) so that adding
// a new union variant turns every switch that must handle it into a
// compile error instead of a silent fall-through.
export function assertNever(x) {
    throw new Error(`assertNever: unexpected variant ${JSON.stringify(x)}`);
}
// Portable base64 → Uint8Array. `atob` is globally available in Node 16+
// and every browser. Malformed input (bad alphabet, or a length/padding
// `atob` rejects — e.g. a dropped `=`) decodes to EMPTY rather than
// trapping the script. This is the single decoder shared by the runtime
// `base64_decode` builtin (runtime/base-env.ts) AND the compile-time
// literal guard (types/checker.ts), so the two can never disagree about
// what counts as valid: the checker flags exactly the literals this
// returns empty for.
export function decodeBase64(s) {
    try {
        const bin = atob(s.replace(/\s+/g, ""));
        const out = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; i++)
            out[i] = bin.charCodeAt(i) & 0xff;
        return out;
    }
    catch {
        return new Uint8Array(0);
    }
}
//# sourceMappingURL=util.js.map